module.exports = __webpack_public_path__ + "8c2d01ade48dcdf7fa3f614b4a46bfdc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/trillium_mutual_funds.png
// module id = 1753
// module chunks = 0